// extracted by mini-css-extract-plugin
export var container = "Container-module--container--3bdec";
export var thin = "Container-module--thin--25a61";
export var ultrathin = "Container-module--ultrathin--1e19e";
export var wide = "Container-module--wide--a1f47";